App.PromosIndexController = Em.Controller.extend
  needs: [ 'promos' ]

  env:     Em.inject.service('environment')
  advertsEnabled: Em.computed.alias('env.features.advertsEnabled')
  promosEnabled: Em.computed.alias('env.features.promosEnabled')
  loyaltyEnabled: Em.computed.alias('env.features.loyaltyProgramsEnabled')

  promosBinding: 'model'

  currentTab: 'active'

  currentPromos: (->
    promos = @get('promos')
    currentTab = @get('currentTab')
    promos.filter (promo) -> 
      if currentTab == 'archive'
      then moment(promo.get('actual_till')) < moment() or not promo.get('is_working')
      else (moment(promo.get('actual_till')) > moment() or not promo.get('actual_till')) and promo.get('is_working') 
  ).property('currentTab', 'promos.[]','promos.@each.actual_till', 'promos.@each.is_working' )


  actions:
    openPromo: (promo) ->
      @transitionToRoute 'promos.promo.edit', promo.get('id')